import { PropsWithChildren } from 'react';
import { UIRouterContext } from '@uirouter/react';
import { registerStateChangeHooks } from '../../../hooks/state-change.hook';
import { initRouterConfigs } from 'services/router/router.rules';
import { appRouter } from 'services/router/router.service';
import { registerAppRouteStates } from 'services/router/register-app-route-states';

export const UiRouter: React.FC<PropsWithChildren> = ({ children }) => {
  if (!appRouter.started) {
    initRouterConfigs();
    registerStateChangeHooks();
    registerAppRouteStates();

    appRouter.start();
  }

  return <UIRouterContext.Provider value={appRouter}>{children}</UIRouterContext.Provider>;
};
